import React, { useState, useEffect } from 'react';
import CallAPI from '../commonComponents/AxiosHelper';
import LoadingComponent from '../commonComponents/LoadingComponent';
import { connect } from 'react-redux';
import { setTableData } from '../../action/index';
import { bindActionCreators } from 'redux';
import FolderView from "./FolderView";
import FileUpload from "./FileUpload";


function DBManagementComponent(props) {

    const [dbManagement, setdbManagement] = useState([])
    const [clickInfo, setClickInfo] = useState({})

    useEffect(() => {
        getInitialData()
    }, [])

    const getInitialData = () => {
        let params = {
            siteId: props.authData.siteId ? props.authData.siteId : null,
            userId: props.authData.userId ? props.authData.userId : null
        }
        setdbManagement([]);
        CallAPI('post', '/app/getdbManagement', null, params, 0, function (response) {

            let newData = []
            if (response.data.length > 0)
                newData = response.data.map(function (innerData) {
                    let tempData = innerData;
                    tempData['description'] = `Rows: ${innerData.total_rows}, Columns: ${innerData.total_cols}`
                    return tempData
                })

            setdbManagement(newData)
        }, props.authData)
    }

    const eventManagement = (type, information) => {
        if (type == "dataQualityReport") {
            let params = {
                siteId: props.authData.siteId ? props.authData.siteId : null,
                userId: props.authData.userId ? props.authData.userId : null,
                type: "pdf",
                auth: "system"
            }
            let data = {
                "tableName": information.raw_table
            }
            CallAPI('POST', '/app/system/fetchDataQuality', data, params, 0, function (response) {
                if (response.pdf)
                    window.open(response.pdf);
                else alert("Something went wrong");
            })
        }
        else setClickInfo({ type: type, information: information })
    }

    let moreOptions = [
        { "id": "viewRawData", "name": "View Raw Data", "link": "/admin/raw_data?raw_data=_replace_name_&tableFlag=0", "target": "_blank", "icon": "database", "type": "link" },
        { "id": "makeDataset", "name": "Make as Dataset", "icon": "plus", "type": "function" },
        { "id": "overwrite", "name": "Overwrite Data", "icon": "refresh-cw", "type": "function" },
        { "id": "append", "name": "Append Data", "icon": "git-commit", "type": "function" },
        { "id": "viewLogs", "name": "View Logs", "link": "/admin/logs?tableName=_replace_name_", "target": "_blank", "icon": "file-text", "type": "link" },
        { "id": "summaryLogs", "name": "Set Log Summary", "icon": "hash", "type": "function" },
        { "id": "dataQualityReport", "name": "Data Quality Report", "icon": "hash", "type": "function" },
    ]
    let dataMapping = { id: "id", name: "tableName", icon: "folder", description: "description", raw_name: "raw_table" }
    let renderComponent = dbManagement.length > 0 ? <FolderView renderData={dbManagement} mapping={dataMapping} moreOptions={moreOptions} eventMore={eventManagement} /> : <LoadingComponent />;

    return (
        <>
            <FileUpload authData={props.authData} clickInfo={clickInfo} renderDataAgain={getInitialData} />
            <div className="">
                {renderComponent}
            </div>
        </>
    );
}

function mapStateToProps(state) {
    return {
        tableData: state.admin.tableData,
        authData: state.dataSet.authData
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setTableData
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DBManagementComponent);